import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes, isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

export const getModifiedApplicationStateForFiu = (state) => {
  const mapping = { OPS_CHECKER: 'Pending', APPROVED: 'Approved', OPS_REJECT: 'Rejected', COMPLETED: 'Completed' }
  return mapping[state] ?? state
}

export const getAcceptableStatusForFiu = (statusArr: any[]) => {
  const mapper = {
    'Pending For Approval': 'OPS_CHECKER',
    Pending: 'OPS_CHECKER',
    Completed: 'COMPLETED',
    Approved: 'APPROVED',
    Rejected: 'OPS_REJECT',
  }

  return statusArr?.map((status) => mapper[status] ?? status)
}

const parser = (dataList: any, count: number) => {
  let parsedList: any[] = []
  dataList?.map((data) => {
    parsedList.push({
      applicationId: data?.applicationId,
      auditType: data?.auditDto?.auditType,
      applicationStatus:
        data?.applicationState === 'OPS_CHECKER'
          ? 'Pending For Approval'
          : getModifiedApplicationStateForFiu(data?.applicationState),
      assignee: data?.opsCheckerUser?.username,
      authorisedSignatory: data?.auditDto?.authorisedSignatory,
      beneficialOwnerDetails: data?.auditDto?.beneficialOwnerDetails,
      businessProfile: data?.auditDto?.businessProfile,
      comments: data?.opsComments?.at(-1)?.comment,
      createdAt: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
      createdBy: data?.opsMakerUser?.username,
      directorDetails: data?.auditDto?.directorDetails,
      identificationNumber: data?.auditDto?.identificationNumber,
    })
  })
  return { list: parsedList, count: count }
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return parser(data?.processInstances, data?.totalItems ?? 0)
}

const getFiuMakerListReq = (
  selectedDateInfo: any,
  pagination: any,
  applicationStatus: any,
  tokens: any,
  auditTypes: any,
  searchBy?: string,
  searchKey?: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.makerApplicationQueue),
    method: 'POST',
    cache: false,
    body: {
      auditSearchFilter: {
        pageNumber: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        pageSize: 10,
        startDate: dateFormatter(selectedDateInfo.fromDate, DateFormatTypes.YYYYMMDD)?.trim(),
        endDate: dateFormatter(selectedDateInfo.toDate, DateFormatTypes.YYYYMMDD)?.trim(),
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            applicationState: getAcceptableStatusForFiu(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
        ...(auditTypes.length > 0 &&
          !auditTypes?.includes('ALL') && {
            auditType: auditTypes,
          }),
        requestType: ['AUDIT'],
        startDateOrder: 'Desc',
        processDefinitionKeyType: 'AUDIT',
      },
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getFiuMakerListReq }
